import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Pet } from 'src/app/interfaces/pet';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { RegistrationProgressService } from 'src/app/services/registration-progress/registration-progress.service';
import { BannerDetails } from 'src/app/interfaces/user';
import { CloudinaryService } from 'src/app/services/cloudinary/cloudinary.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public bannersDetails: BannerDetails[] = [];

  public displayUserIconDropdown: boolean = true;
  public displayNonAuthenticatedHeaderLinkNavBar: boolean = true;
  public purinaPartnerPage: boolean = false;
  isBrowser: boolean;

  constructor(
    public authManager: AuthManagerService,
    private userService: UserService,
    private registrationProgressService: RegistrationProgressService,
    private router: Router,
    private cloudinaryService: CloudinaryService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  get pets(): Pet[] {
    return this.userService.user ? this.userService.filterAliveRegisteredPets(this.userService.user.pets) : [];
  }

  get registrationFinished(): boolean {
    if (!this.userService.user) return true;
    const progress =
      this.registrationProgressService.getRegistrationProgressData(
        this.userService.user
      );
    return (
      progress.isFullNameRegistrationCompleted &&
      progress.isMembershipSelectionCompleted &&
      progress.isPetChipNumberRegistrationCompleted &&
      progress.isWelcomePackSelectCompleted
    );
  }

  ngOnInit(): void {
    this.getBannerData()
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.url;
        if (url.includes('purina')) {
          this.purinaPartnerPage = true
        } else {
          this.purinaPartnerPage = false
        }
      }
    });
  }

  opened(isOpened: boolean): void {
    if (this.isBrowser && isOpened) {
      window.analytics.track('header::menu::opened');
    }
  }

  getBannerData() {
    this.userService.getBannersDetails().subscribe(
      (details: BannerDetails[]) => {
        this.bannersDetails = details;
      },
      (error) => {
        console.error('Error fetching banner details', error);
      }
    );
  }

  public getPetImageUrl(petImageId: string): string {
    return this.cloudinaryService.getImageUrl(petImageId, 88, 88, null);
  }
}
